import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { HttpWrapperService } from '../http-wrapper.service';
import { IHttpRequestOptions } from '../../interfaces/http-request-option.interface';
import {
  ITicketHolder,
  ITicketHolderFilter,
  ICheckInRequest,
  ITicket,
  ICheckInByQRResponse,
} from '../../interfaces/checkinmanager.interface';
import { HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class CheckInManagerService {
  constructor(private httpWrapperService: HttpWrapperService) {}

  /**
   * Get ticket holders with filtering (POST CheckInManager/ticket-holders)
   */
  getTicketHolders(filter: ITicketHolderFilter): Observable<ITicketHolder[]> {
    const url = 'CheckInManager/ticket-holders';
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const body = {
      searchTerm: filter.searchTerm ?? null,
      itemId: filter.itemId ?? null,
      checkInStatus: filter.checkInStatus ?? null,
      campaignId: filter.campaignId,
    };
    const options: IHttpRequestOptions = {
      url,
      headers,
      body,
    };
    return this.httpWrapperService
      .postFromApiGateWay(options)
      .pipe(map((response: ITicketHolder[]) => response));
  }

  /**
   * Check in or uncheck a ticket (POST CheckInManager/check-in)
   */
  checkInTicket(request: ICheckInRequest): Observable<boolean> {
    const url = 'CheckInManager/check-in';
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const options: IHttpRequestOptions = {
      url,
      headers,
      body: request,
    };
    return this.httpWrapperService
      .postFromApiGateWay(options)
      .pipe(map((response: boolean) => response));
  }

  /**
   * Get ticket by QR code (GET CheckInManager/ticket/qr/{qrCode})
   */
  getTicketByQRCode(qrCode: string): Observable<ITicket | null> {
    const encoded = encodeURIComponent(qrCode);
    const url = `CheckInManager/ticket/qr/${encoded}`;
    const options: IHttpRequestOptions = { url };
    return this.httpWrapperService
      .getFromApiGateWay(options)
      .pipe(map((response: ITicket | null) => response ?? null));
  }

  /**
   * Check in a ticket by QR code (POST CheckInManager/check-in/qr).
   * Returns { status: 'CheckedIn' | 'AlreadyCheckedIn' }. 404 if ticket invalid/not found.
   */
  checkInTicketByQRCode(qrCode: string,campaignId: number): Observable<ICheckInByQRResponse> {
    const url = `CheckInManager/check-in/qr/${campaignId}`;
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const options: IHttpRequestOptions = {
      url,
      headers,
      body: { qrCode },
    };
    return this.httpWrapperService
      .postFromApiGateWay(options)
      .pipe(map((response: ICheckInByQRResponse) => response));
  }
}
